import { withInstall } from '../utils/index';
import './index.less';
import _Swiper from './swiper.vue';
import { SwiperSlide as _SwiperSlide } from 'swiper/vue';

export const TlbsSwiper = withInstall(_Swiper);
export const TlbsSwiperSlide = withInstall(_SwiperSlide);
export default TlbsSwiper;
